import type { PromotionPayload, PromotionPool } from 'api/promotion'

// `codesCsvState` transitions pending → generating → generating_csv → complete.
// The list API has been observed returning `codesCsvState: 'generating'` after
// codes have finalized (totalCodes > 0, URL populated), so URL presence is
// the source of truth for CSV readiness; state is just a hint for "not yet
// started".
export const IN_PROGRESS_STATES: ReadonlySet<string> = new Set([
  'pending',
  'generating',
  'generating_csv',
])

// CSV artifact not yet available for download. Used to drive the
// "Generating CSV..." disabled button state on Detail and PromotionRow.
export const isCsvGenerating = (pool: PromotionPool): boolean =>
  !pool.codesCsvUrl &&
  !!pool.codesCsvState &&
  IN_PROGRESS_STATES.has(pool.codesCsvState)

// Code rows not yet persisted. Drives the "Generating…" placeholder in the
// Number-of-codes count on Detail and the Landing row's code cell.
export const areCodesStillGenerating = (pool: PromotionPool): boolean =>
  pool.totalCodes === 0 && isCsvGenerating(pool)

// Row-level predicate for the Landing list polling loop. Only true while
// the "Generating codes…" cell is still shown — once `totalCodes > 0` the
// cell shows the count and there's nothing left to observe.
export const hasGeneratingPool = (promotion: PromotionPayload): boolean => {
  const pool = promotion.pool
  return !!pool && areCodesStillGenerating(pool)
}
